import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode");
  if (codeEntite) {
    config.headers["ref_entity"] = `client_${codeEntite}`;
  } else {
    config.headers["ref_entity"] = null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeDeToutLesPaiements = async (
  page,
  size,
  param = "",
  niveau = "",
  service = "",
  debut = "",
  fin = ""
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/listepaiements?dateDebut=${debut}&dateFin=${fin}&page=${page}&param=${param}&serviceId=${service}&niveauId=${niveau}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getLeResteApayer = async (annee, eleve, service) => {
  return await axios.get(
    BASE_URL(
      `etablissement/resteapayereleves/?anneeId=${annee}&eleveId=${eleve}&serviceId=${service}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const enregistrerPaiementEleve = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/enregistrerpaiement"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const exportToutPaiement = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/listepaiements/export-to-excel"),
    values,
    { responseType: "blob" }
  );
};

export const exportToutPaiementPdf = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/exporterpaiementspdf"),
    values,
    { responseType: "blob" }
  );
};

export const exportDesRapportJournalierPdf = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/exporterrapportjournlier"),
    values,
    { responseType: "blob" }
  );
};

export const totalPaiment = async () => {
  return await axios.get(BASE_URL(`etablissement/totalpaiement`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const deleteNiveauEtude = async (id) => {
  return await axios.delete(BASE_URL(`etablissement/supprimerniveau/${id}`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

// /etablissement/enregistrerpaiement?idService=idService&codeEtablissement=codeEtablissement

export const paiementViaQR = async (values, codeEtablissement) => {
  return await axios.post(
    BASE_URL(`clientfree/enregistrerpaiementfacture/${codeEtablissement}`),
    values
    // { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const verificationPaiementViaQR = async (reference) => {
  return await axios.get(
    BASE_URL(`clientfree/verifierstatutpaiement/${reference}`),
    {}
    // { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};
